import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent } from '../components/ui/Card';
import { GraduationCap, Building2, School } from 'lucide-react';
export function LoginPage() {
  const [userType, setUserType] = useState<'student' | 'landlord' | 'university'>('student');
  const navigate = useNavigate();
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/dashboard/${userType}`);
  };
  return <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-774">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-775">
        <Link to="/" className="flex justify-center items-center gap-2 mb-6" data-id="element-776">
          <img src="https://cdn.magicpatterns.com/uploads/37CjFFhCaYFTTZ1oinSNtZ/Cam_main_ver_logo.png" alt="CampusAparte" className="h-12 w-auto" data-id="element-777" />
        </Link>
        <h2 className="text-center text-3xl font-bold tracking-tight text-brand-dark" data-id="element-778">
          Sign in to your account
        </h2>
        <p className="mt-2 text-center text-sm text-slate-600" data-id="element-779">
          Or{' '}
          <Link to="/signup" className="font-medium text-brand-primary hover:text-brand-light" data-id="element-780">
            create a new account
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-781">
        <Card data-id="element-782">
          <CardContent className="p-8" data-id="element-783">
            {/* User Type Selector */}
            <div className="grid grid-cols-3 gap-2 mb-8 p-1 bg-slate-100 rounded-lg" data-id="element-784">
              {[{
              id: 'student',
              icon: GraduationCap,
              label: 'Student'
            }, {
              id: 'landlord',
              icon: Building2,
              label: 'Landlord'
            }, {
              id: 'university',
              icon: School,
              label: 'Admin'
            }].map(type => <button key={type.id} onClick={() => setUserType(type.id as any)} className={`flex flex-col items-center justify-center py-2 rounded-md text-xs font-medium transition-all ${userType === type.id ? 'bg-white text-brand-dark shadow-sm ring-1 ring-slate-200' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-785">
                  <type.icon className={`w-5 h-5 mb-1 ${userType === type.id ? 'text-brand-primary' : ''}`} data-id="element-786" />
                  {type.label}
                </button>)}
            </div>

            <form className="space-y-6" onSubmit={handleLogin} data-id="element-787">
              <Input label="Email address" type="email" placeholder={userType === 'university' ? 'admin@university.edu.ng' : 'you@example.com'} required data-id="element-788" />

              <div data-id="element-789">
                <Input label="Password" type="password" required data-id="element-790" />
                <div className="flex justify-end mt-1" data-id="element-791">
                  <a href="#" className="text-sm font-medium text-brand-primary hover:text-brand-light" data-id="element-792">
                    Forgot password?
                  </a>
                </div>
              </div>

              <Button type="submit" className="w-full" data-id="element-793">
                Sign in as{' '}
                {userType.charAt(0).toUpperCase() + userType.slice(1)}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>;
}